import { render, staticRenderFns } from "./TeamOverview.vue?vue&type=template&id=49146d9f&lang=pug&"
import script from "./TeamOverview.vue?vue&type=script&lang=js&"
export * from "./TeamOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports